import { render, staticRenderFns } from "./dateTextShadow.vue?vue&type=template&id=0d2e21d9&"
import script from "./dateTextShadow.vue?vue&type=script&lang=ts&"
export * from "./dateTextShadow.vue?vue&type=script&lang=ts&"
import style0 from "./dateTextShadow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports